import React, { useCallback } from 'react';
import { FlatList } from 'react-native';
import { ListItem, withTheme } from '@rneui/themed';
import { FAIcon, Modal } from '../../elements';
export const UnthemedFilter = ({ parent, selected, items, isVisible, onToggleOverlay, onLoadMore, setFilter, }) => {
    const depthMap = {
        [parent.id]: 0,
        ...(items.reduce((acc, i) => {
            acc[i.item.id] = i.depth || 0;
            return acc;
        }, {}))
    };
    const collections = [parent, ...(items.map(i => i.item))];
    const renderItem = useCallback(({ item }) => {
        const isSelected = item.id === selected?.id;
        return (React.createElement(ListItem, { onPress: () => {
                setFilter(item);
                onToggleOverlay();
            }, style: { paddingLeft: depthMap[item.id] * 30 } },
            React.createElement(ListItem.Content, null,
                React.createElement(ListItem.Title, null, item.id === parent.id ? 'All' : item.name)),
            isSelected && (React.createElement(FAIcon, { name: "check" }))));
    }, [
        selected?.id,
        setFilter,
        onToggleOverlay,
        parent.id,
        Object.keys(depthMap).toString(),
    ]);
    return (React.createElement(Modal, { isVisible: isVisible, onCloseModal: onToggleOverlay, onBackdropPress: onToggleOverlay, onBackButtonPress: onToggleOverlay, style: {
            maxHeight: '90%'
        } },
        React.createElement(FlatList, { keyExtractor: (item, index) => `${item.id}-${index}`, data: collections, renderItem: renderItem, onEndReached: onLoadMore, onEndReachedThreshold: 0.5, onScrollToIndexFailed: () => { } })));
};
export const Filter = withTheme(UnthemedFilter, 'Filter');
//# sourceMappingURL=Filter.js.map